import React from "react";
import { Stack, Typography } from "@mui/material";

function NoAccess() {
  return (
    <Stack
      width="100%"
      height="100vh"
      alignItems="center"
      justifyContent="center"
    >
      <Typography variant="h2" sx={{ color: "#4EAF51" }}>
        You have no Access to this Feature
      </Typography>
    </Stack>
  );
}

export default NoAccess;
